import React from 'react';
import styled from 'styled-components';
import { fontSize } from '../../mixins';
import { GreenCircle, WhiteBigCircle } from './icons';
import PackageOptions from './PackageOptions';


const PackageListWrapper = styled.div`
  display: flex;
  flex-direction: column${({type_optionsh}) => type_optionsh ? '-reverse' : ''};
  padding: 10px;
  margin-top: 10px;
  overflow-x: hidden;
`;

const StyledPackageList = styled.div`
  width: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
  position: relative;
  
  @media screen and (max-width: 430px) {
    margin-bottom: 24px;
  }
  
  @media screen and (max-width: 330px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const StyledDiscountWrapper = styled.div`
  width: 100%;
  height: 30px;
  padding-left: 12px;
  padding-right: 12px;
  background: #f2994a;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 0px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
`;

const StyledDiscountTitle = styled.span`
  font-weight: 800;
  ${fontSize(12)};
  line-height: 16px;
  letter-spacing: -0.46px;
  color: #fff;
`;

const StyledDiscountPrice = styled.span`
  font-weight: 800;
  ${fontSize(12)};
  letter-spacing: -0.46px;
  color: #fff;
`;

const StyledPackageWrapper = styled.div`
  padding-top: 32px;
  width: 160px;
  height: 160px;
  background: ${(props) => props.active ? '#F2994A': 'transparent'};
  box-shadow: ${(props) => props.active ? '0px 4px 20px rgba(0, 0, 0, 0.25)' : 'none'};
  display:flex;
  justify-content: center;
  align-items: center;
  border: ${(props) => props.active ? '3px solid #F2994A' : 'none'};
  border-radius: 16px;
  position: relative;
`;

const StyledPackageContent = styled.div`
  width: 98%;
  height: 98%;
  background-color: white;
  border-radius: 12px;
  
  button {
    width: 160px;
    height: 100%;
    color: #fff;
    display: flex;
    align-items: center;
    background-color: transparent;
    border: none;
    padding: ${(props) => props.active ? '24px 8px' : '25px 0px 28px 17px'};
    cursor: pointer;
    
    @media screen and (max-width: 430px) {
      width: inherit;
      max-width: 160px;
    }
    
    &:focus {
      outline: none;
    }
  }
`;

const StyledPackageIcon = styled.div`
  position: absolute;
  right: 10px;
  top: 40px;
`;

const StyledPriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 90%;
`;

const StyledPackageName = styled.div`
  font-weight: 800;
  ${fontSize(18)};
  line-height: 16px;
  margin-bottom: 8px;
  color:${(props) => props.active ? '#f2994a' : '#5B5B5B;'};
`;

const StyledPriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
`;

const StyledOldPrice = styled.span`
  font-weight: 400;
  ${fontSize(14)};
  letter-spacing: -0.46px;
  color: #b1b1b1;
  text-decoration: line-through;
  color: #b1b1b1;
  margin-bottom: 8px;
`;

const StyledNewPrice = styled.span`
  font-weight: 700;
  ${fontSize(18)};
  letter-spacing: -0.46px;
  color:${(props) => props.active ? '#00a08b' : '#6C797D'};
`;

const StyledOptionsWrapper = styled.div`
    overflow-x: scroll;
    margin: 10px 0;
   
    &::-webkit-scrollbar {
       display: none;
    }
    
    @media screen and (min-width: 430px) {
        margin: 30px 0
    }
`;


const PackagePlans = ({currentPlans,onPlanClick,plan,landingType}) => {
    const optionsh = landingType === 'optionsh';
    const firstPlanId = currentPlans[0].id;

    const renderPackage = (i, index) => {
        const isActive = firstPlanId === i.id;

        return <React.Fragment key={i.id}>
            <StyledPackageWrapper active={i.saveAmount}>
                <StyledPackageContent active={i.saveAmount}>
                    {i.saveAmount && (
                        <StyledDiscountWrapper>
                            <StyledDiscountTitle>
                              BEST SELLER
                            </StyledDiscountTitle>
                            <StyledDiscountPrice>-{i.saveAmount}</StyledDiscountPrice>
                        </StyledDiscountWrapper>
                    )}
                    <button onClick={() => onPlanClick(i.id)} id={'plan-button-' + (index + 1)}>
                        <StyledPriceContainer>
                            <StyledPackageName active={isActive}>{i.title.toUpperCase()}</StyledPackageName>
                            <StyledPriceWrapper>
                                <StyledOldPrice>
                                    {i.prevPrice} {i.week}
                                </StyledOldPrice>
                                <StyledNewPrice active={isActive}>
                                    {i.weeklyPrice} / {i.period}
                                </StyledNewPrice>
                            </StyledPriceWrapper>
                        </StyledPriceContainer>
                        <StyledPackageIcon>
                            {plan === i.id ? GreenCircle : WhiteBigCircle}
                        </StyledPackageIcon>
                    </button>
                </StyledPackageContent>
            </StyledPackageWrapper>
        </React.Fragment>;
    };


    return (
        <PackageListWrapper type_optionsh={optionsh}>
            <StyledPackageList type_optionsh={optionsh} >
                {currentPlans.map(renderPackage)}
            </StyledPackageList>
            <StyledOptionsWrapper type_optionsh={optionsh}>
                <PackageOptions active={firstPlanId === plan}/>
            </StyledOptionsWrapper>
        </PackageListWrapper>
    );
};

export default PackagePlans;
